import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import Moment from "moment";
import { extendMoment } from "moment-range";
import { useSelector } from "react-redux";
import CalenderWrapper from "./Calender.style";
import { Modal } from "antd";
import { useIntl } from "react-intl";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import CustomEvent from "./CustomEvent";
import {
  isSchedulingAllowedOverlapping,
  isLoadingHours,
} from "../../../components/util/helpers";
import { ExclamationCircleOutlined } from "@ant-design/icons";
const moment = extendMoment(Moment);
const localizer = momentLocalizer(moment);
const DragAndDropCalendar = withDragAndDrop(Calendar);

const Calender = (props) => {
  const {
    currentDate,
    onNavigate,
    calenderView,
    events,
    patientsPallette,
    viewEvent,
    goToDayView,
    filteredOrders,
    holidays,
    absences,
    changeEvent,
    createEvent,
  } = props;
  const [modal, contextHolder] = Modal.useModal();
  const intl = useIntl();

  const displayDragItemInCell = true;
  const [monthAbsencesDates, setMonthAbsencesDates] = useState([]);
  const [monthAbsencesDays, setMonthAbsencesDays] = useState([]);

  const [draggedEvent, setDraggedEvent] = useState(null);

  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  const localeLang = "he";
  var startOfMonth = moment().startOf("month").toDate();
  const onView = (val) => {};
  useEffect(() => {
    let absencesDates = [];
    for (let i = 0; i < absences.length; i++) {
      const range = moment.range(
        absences[i].effective_from,
        absences[i].effective_to
      );
      const monthRange = moment.range(
        moment(currentDate).startOf("month"),
        moment(currentDate).endOf("month")
      );
      if (range.overlaps(monthRange, { adjacent: false })) {
        const dates = getDaysBetweenDates(
          moment(absences[i].effective_from),
          moment(absences[i].effective_to),
          monthRange,
          absences[i].reason_id,
          absences[i].reason.type,
          absences[i].reason.name
        );
        absencesDates = [...absencesDates, ...dates];
      }
    }
    setMonthAbsencesDates(absencesDates);
    const absencesDays = absencesDates.map((j) => moment(j.date).format("DD"));
    setMonthAbsencesDays(absencesDays);
  }, [currentDate, absences]);

  const getDaysBetweenDates = (
    startDate,
    endDate,
    range,
    reason_id,
    type,
    name
  ) => {
    var now = startDate.clone(),
      dates = [];
    while (now.isSameOrBefore(endDate)) {
      if (moment(now).within(range)) {
        dates.push({ date: now.format(), reason_id, type, name });
      }
      now.add(1, "days");
    }
    return dates;
  };

  const isAbsenceDay = (date) => {
    const isWithinAbsences = monthAbsencesDays.includes(
      moment(date).format("DD")
    );
    return isWithinAbsences;
  };

  const getAbsenceType = (date) => {
    let absence = null;
    for (let i = 0; i < absences.length; i++) {
      const range = moment.range(
        absences[i].effective_from,
        absences[i].effective_to
      );
      if (moment(date).within(range)) {
        absence = absences[i];
      }
    }
    return absence && absence.reason.type;
  };

  const dayPropGetter = (date) => {
    const noSchedulingView =
      (calenderView === Views.WEEK &&
        !moment(moment(date)).isSame(moment(currentDate), "month")) ||
      isAbsenceDay(date);
    const type = getAbsenceType(date);
    return (
      noSchedulingView && {
        style: { backgroundColor: "#e6e6e6" },
        className: type ? "absence" : "",
      }
    );
  };

  const eventStyleGetter = (event, start, end, isSelected) => {
    const order_id =
      event["order"] && event["order"]["id"] ? event["order"]["id"] : null;
    const patientColor = order_id
      ? patientsPallette.filter((item) => item.orderId === order_id)[0]
      : null;

    var style = {
      backgroundColor: event.ghost
        ? "white"
        : patientColor
        ? patientColor.bg
        : event.holiday
        ? "#19adf8"
        : event.absence && event.type === 1
        ? "transparent"
        : event.absence && event.type === 2
        ? "transparent"
        : event.absence && event.type === 3
        ? "transparent"
        : event.absence && event.type === 4
        ? "transparent"
        : "black",
      opacity: order_id || event.holiday || event.absence ? 1 : 0.4,
      borderColor: event.ghost
        ? "red"
        : !event.recurrent_id && !event.absence && !event.holiday
        ? "#000000"
        : patientColor
        ? patientColor.border
        : event.holiday
        ? "#19adf8"
        : event.absence && event.type === 1
        ? "transparent"
        : event.absence && event.type === 2
        ? "transparent"
        : event.absence && event.type === 3
        ? "transparent"
        : event.absence && event.type === 4
        ? "transparent"
        : "black",
      borderStyle:
        event.ghost || (!event.recurrent_id && !event.absence && !event.holiday)
          ? "dashed"
          : "solid",
      borderWidth:
        event.absence || event.holiday
          ? "0px"
          : event.recurrent_id
          ? "1px"
          : "3px",
    };
    return {
      style: style,
    };
  };

  const isOtherMonth = (date) => {
    const differentMonth =
      calenderView === Views.WEEK &&
      !moment(moment(date)).isSame(moment(currentDate), "month");
    return differentMonth;
  };

  const handleDragStart = (event) => {
    setDraggedEvent(event);
  };

  const dragFromOutsideItem = () => {
    return draggedEvent;
  };

  const moveEvent = ({ event, start, end }) => {
    if (moment(end) > moment(start).endOf("day")) {
      end = moment(start).endOf("day").toDate();
    }
    shouldChangeEvent(event, start, end);
  };

  const resizeEvent = ({ event, start, end }) => {
    shouldChangeEvent(event, start, end);
  };

  const shouldChangeEvent = (event, start, end) => {
    // Check if duration is less than 15 minutes
    const durationMinutes = moment(end).diff(moment(start), "minutes");
    if (durationMinutes < 15) {
      return;
    }

    const differentMonth = isOtherMonth(start);
    const isAllowedOverlapping = isSchedulingAllowedOverlapping(
      events,
      event,
      start,
      end
    );

    const loadingHours = isLoadingHours(events, event, start, end);
    if (loadingHours && isAllowedOverlapping) {
      const title = intl.formatMessage({
        id: "app.scheduling.overlappingEventsModalTitle",
      });
      const content = intl.formatMessage({
        id: "app.scheduling.overlappingEventsModalDescription",
      });
      modal.confirm({
        title: title,
        icon: <ExclamationCircleOutlined />,
        content: content,
        onOk() {
          return changeEvent(event, start, end);
        },
        onCancel() {},
      });
    } else if (
      !event.prospectus_id &&
      !differentMonth &&
      isAllowedOverlapping
    ) {
      changeEvent(event, start, end);
    }
  };

  const onSelectSlot = (event) => {
    const differentMonth = isOtherMonth(event.start);

    if (calenderView === Views.MONTH) {
      if (event.action === "doubleClick") {
        goToDayView(event);
      }
    } else if (!differentMonth && !isAbsenceDay(event.start)) {
      createEvent(event);
    }
  };

  const onDoubleClickEvent = (event) => {
    if (
      (!event.nonAvailable && !event.holiday && !event.absence) ||
      event.ghost
    ) {
      viewEvent(event);
    }
  };

  const getNonAvailabaleDays = (weekDay) => {
    var dayInWeek = moment(currentDate).startOf("month").day(weekDay);
    let arr = [];
    if (dayInWeek.date() > 7) dayInWeek.add(7, "d");
    var month = dayInWeek.month();
    while (month === dayInWeek.month()) {
      arr.push(dayInWeek.format());
      dayInWeek.add(7, "d");
    }
    return arr;
  };

  let tableEvents = [];
  if (patientsPallette.length > 0) {
    events.forEach((item, i) => {
      var isFiltered = filteredOrders.includes(item.order_id);
      if (!isFiltered) {
        tableEvents.push(item);
      }
    });
  }

  holidays.forEach((item, i) => {
    const religion = activeEmployee.religion_id || 1;
    if (item.religion_id === religion) {
      tableEvents.push({
        title: item.name,
        start: moment(item.date).startOf("day").toDate(),
        end: moment(item.date).endOf("day").toDate(),
        date: item.date,
        holiday: true,
        id: 100000000 + i,
      });
    }
  });

  monthAbsencesDates.forEach((item, i) => {
    tableEvents.push({
      title: item.name,
      type: item.type,
      start: moment(item.date).startOf("day").toDate(),
      end: moment(item.date).endOf("day").toDate(),
      date: item.date,
      absence: true,
      id: 200000000 + i,
    });
  });

  if (
    activeEmployee.non_available_periods &&
    activeEmployee.non_available_periods.length > 0
  ) {
    activeEmployee.non_available_periods.forEach((period) => {
      // Check if the period is currently active
      const effectiveFrom = moment(period.effective_from);
      const effectiveTo = period.effective_to
        ? moment(period.effective_to)
        : moment().add(100, "years"); // If no end date, set a far future date

      // Check if the current month overlaps with the effective period
      const monthStart = moment(currentDate).startOf("month");
      const monthEnd = moment(currentDate).endOf("month");
      const periodRange = moment.range(effectiveFrom, effectiveTo);
      const monthRange = moment.range(monthStart, monthEnd);

      if (periodRange.overlaps(monthRange, { adjacent: false })) {
        // Period is active for the current month, process the non-available hours
        if (
          period.non_available_hours &&
          period.non_available_hours.length > 0
        ) {
          period.non_available_hours.forEach((item, i) => {
            const days = getNonAvailabaleDays(item.day_of_week);
            days.forEach((day, j) => {
              // Check if this specific day is within the effective period
              const dayDate = moment(day);
              if (dayDate.isBetween(effectiveFrom, effectiveTo, null, "[]")) {
                const startDate = moment(day).set(
                  "minute",
                  item.start_time_minutes
                );
                const nonAvailableStart = startDate.toDate();
                const nonAvailableEnd = moment(startDate)
                  .add(item.duration_minutes, "minutes")
                  .toDate();
                tableEvents.push({
                  start: nonAvailableStart,
                  end: nonAvailableEnd,
                  nonAvailable: true,
                  id: 20000 + i * 100 + j, // Ensure unique IDs
                  title: item.description || "Non-available",
                  place: item.place || "",
                });
              }
            });
          });
        }
      }
    });
  }

  return (
    <CalenderWrapper>
      {contextHolder}
      <DragAndDropCalendar
        popup
        view={calenderView}
        onView={onView}
        date={currentDate.toDate()}
        rtl={localeLang === "he"}
        onNavigate={onNavigate}
        selectable
        localizer={localizer}
        events={tableEvents}
        resizable
        defaultView={Views.MONTH}
        defaultDate={startOfMonth}
        drilldownView={Views.DAY}
        toolbar={false}
        eventPropGetter={eventStyleGetter}
        dayPropGetter={dayPropGetter}
        tooltipAccessor={null}
        onSelectSlot={onSelectSlot}
        draggableAccessor={(event) =>
          calenderView !== Views.MONTH &&
          !event.absence &&
          !event.holiday &&
          !event.nonAvailable &&
          !event.approved
        }
        onEventDrop={moveEvent}
        onEventResize={resizeEvent}
        onDoubleClickEvent={onDoubleClickEvent}
        dragFromOutsideItem={displayDragItemInCell ? dragFromOutsideItem : null}
        handleDragStart={handleDragStart}
        showMultiDayTimes
        scrollToTime={new Date(1970, 1, 1, 8)}
        components={{
          event: (prop) => (
            <CustomEvent
              event={prop.event}
              patientsPallette={patientsPallette}
              eventProps={prop}
            />
          ),
        }}
        style={{ height: "calc(100vh - 370px)" }}
      />
    </CalenderWrapper>
  );
};

export default Calender;
